var _g, _path, _path2, _path3, _path4, _path5, _line, _line2, _path6, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaffeine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Caffeine",
    xmlns: "http://www.w3.org/2000/svg",
    width: 109,
    height: 112,
    viewBox: "0 0 109 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-0.135 0.024)",
    opacity: 0.282
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Icon.BG",
    cx: 54.5,
    cy: 56,
    rx: 54.5,
    ry: 56,
    transform: "translate(0.135 -0.024)",
    fill: "#c3af92"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17545",
    "data-name": "Path 17545",
    d: "M638.7,809.038c-2.769-.618-5.7,1.978-6.972,7.654s-.387,12.282,2.382,12.9,6.377-4.986,7.644-10.662-.285-9.275-3.054-9.893",
    transform: "translate(-803.179 661.857) rotate(-88)",
    fill: "#c3af92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14621",
    "data-name": "Path 14621",
    d: "M634.271,839.24c-4.129,4.1-6.951,10.133-4.954,12.148s8.059-.758,12.188-4.854,4.763-7.963,2.766-9.977-5.871-1.413-10,2.683",
    transform: "translate(-576.313 -774.505)",
    fill: "#c3af92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14622",
    "data-name": "Path 14622",
    d: "M641.434,833.9c-2.557,0-5.486,1.509-8.247,4.248a24.293,24.293,0,0,0-5.107,7.342c-1.317,3.082-1.266,5.562.145,6.984a4.1,4.1,0,0,0,3.038,1.128c3.125,0,7.783-2.456,11.328-5.972,5.165-5.122,5.115-9.8,2.774-12.157a5.4,5.4,0,0,0-3.931-1.573m-1.013,11.542c-3.205,3.179-7.174,5.078-9.158,5.078a1.279,1.279,0,0,1-.851-.216c-.291-.294-.4-1.5.5-3.6a21.425,21.425,0,0,1,4.442-6.366c2.15-2.131,4.365-3.354,6.078-3.354a2.359,2.359,0,0,1,1.743.661c1.491,1.5.357,4.711-2.756,7.8",
    transform: "translate(-576.313 -774.505)",
    fill: "#4d391b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14623",
    "data-name": "Path 14623",
    d: "M638.7,809.038c-2.769-.618-5.7,1.978-6.972,7.654s-.387,12.282,2.382,12.9,6.377-4.986,7.644-10.662-.285-9.275-3.054-9.893",
    transform: "translate(-576.313 -774.505)",
    fill: "#c3af92"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14624",
    "data-name": "Path 14624",
    d: "M639.04,807.534a5.23,5.23,0,0,0-1.139-.125c-3.5,0-6.441,3.428-7.673,8.948-1.2,5.358-.894,13.748,3.55,14.74a3.5,3.5,0,0,0,.766.084c4.179,0,7.614-6.967,8.719-11.914a14.468,14.468,0,0,0-.06-7.677,5.776,5.776,0,0,0-4.163-4.056m1.215,11.061c-1.211,5.423-4.3,9.5-5.711,9.5l-.094-.01c-1.17-.262-2.516-5.226-1.214-11.06,1.008-4.517,3.07-6.538,4.665-6.538a2.182,2.182,0,0,1,.467.051,2.861,2.861,0,0,1,1.919,2.044,11.163,11.163,0,0,1-.032,6.009",
    transform: "translate(-576.313 -774.505)",
    fill: "#4d391b"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_114",
    "data-name": "Line 114",
    x1: 5,
    y2: 19,
    transform: "translate(57.389 35.153)",
    fill: "none",
    stroke: "#4d391b",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_115",
    "data-name": "Line 115",
    x1: 14,
    y2: 13,
    transform: "translate(53.389 63.153)",
    fill: "none",
    stroke: "#4d391b",
    strokeWidth: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17544",
    "data-name": "Path 17544",
    d: "M639.04,807.534a5.23,5.23,0,0,0-1.139-.125c-3.5,0-6.441,3.428-7.673,8.948-1.2,5.358-.894,13.748,3.55,14.74a3.5,3.5,0,0,0,.766.084c4.179,0,7.614-6.967,8.719-11.914a14.468,14.468,0,0,0-.06-7.677,5.776,5.776,0,0,0-4.163-4.056m1.215,11.061c-1.211,5.423-4.3,9.5-5.711,9.5l-.094-.01c-1.17-.262-2.516-5.226-1.214-11.06,1.008-4.517,3.07-6.538,4.665-6.538a2.182,2.182,0,0,1,.467.051,2.861,2.861,0,0,1,1.919,2.044,11.163,11.163,0,0,1-.032,6.009",
    transform: "translate(-781.923 690.839) rotate(-90)",
    fill: "#4d391b"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_190",
    "data-name": "Line 190",
    x1: 5,
    y2: 19,
    transform: "translate(27.735 57.137) rotate(-90)",
    fill: "none",
    stroke: "#4d391b",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaffeine);
export default __webpack_public_path__ + "static/media/Caffeine.1d317343fc489831149e818060ac022b.svg";
export { ForwardRef as ReactComponent };